(function () {
  var STORAGE_KEY = "web-riddle-box-v1";

  function boot() {
    var root = document.querySelector('.puzzle-page[data-puzzle="riddle-box"]');
    if (!root || root.getAttribute("data-booted") === "1") return;
    root.setAttribute("data-booted", "1");
    startPuzzle(root);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  function startPuzzle(root) {
    function q(id) { return root.querySelector("#" + id); }

    var nodes = {
      dek: q("dek"),
      caseSeed: q("case-seed"),
      letter: q("letter"),
      progress: q("progress"),
      status: q("status"),
      nav: q("riddle-nav"),
      view: q("riddle-view"),
      form: q("answer-form"),
      choices: q("choices"),
      reveal: q("reveal"),
      newCase: q("new-case"),
      modal: q("modal"),
      modalYes: q("modal-yes"),
      modalNo: q("modal-no"),
      spoil: q("spoil"),
      spoilYes: q("spoil-yes"),
      spoilNo: q("spoil-no"),
    };

    var state = null;

    function deck() {
      var api = globalThis.RiddleBox;
      if (!api) throw new Error("RiddleBox is missing");
      return api;
    }

    function setStatus(text, kind) {
      nodes.status.textContent = text;
      nodes.status.className = kind || "";
    }

    function randomSeed() {
      var buf = new Uint32Array(1);
      crypto.getRandomValues(buf);
      return buf[0] || 1;
    }

    function fresh(seed) {
      var made = deck().createCase(seed);
      return {
        version: 1,
        seed: made.seed,
        slips: made.slips.slice(),
        index: 0,
        solved: {},
        tried: {},
        revealed: {},
        misses: {},
      };
    }

    function load() {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !Array.isArray(parsed.slips)) return null;
      var made = fresh(parsed.seed);
      if (made.slips.join() !== parsed.slips.join()) return null;
      made.index = parsed.index >= 0 && parsed.index < made.slips.length ? parsed.index : 0;
      made.solved = parsed.solved && typeof parsed.solved === "object" ? parsed.solved : {};
      made.tried = parsed.tried && typeof parsed.tried === "object" ? parsed.tried : {};
      made.revealed = parsed.revealed && typeof parsed.revealed === "object" ? parsed.revealed : {};
      made.misses = parsed.misses && typeof parsed.misses === "object" ? parsed.misses : {};
      return made;
    }

    function save() {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        version: 1,
        seed: state.seed,
        slips: state.slips,
        index: state.index,
        solved: state.solved,
        tried: state.tried,
        revealed: state.revealed,
        misses: state.misses,
      }));
    }

    function currentId() {
      return state.slips[state.index];
    }

    function solvedCount() {
      return state.slips.filter(function (id) { return state.solved[id]; }).length;
    }

    function hasWork() {
      return state.slips.some(function (id) { return state.solved[id] || state.tried[id] || (state.misses[id] && state.misses[id].length); });
    }

    function renderLetter() {
      nodes.letter.replaceChildren();
      deck().introParagraphs.forEach(function (text) {
        var p = document.createElement("p");
        p.textContent = text;
        nodes.letter.append(p);
      });
    }

    function render() {
      var api = deck();
      var slip = api.riddleById(currentId());
      var locked = Boolean(state.solved[slip.id]);
      nodes.caseSeed.textContent = "Case " + api.caseLabel(state.seed);
      nodes.progress.textContent = solvedCount() + " of " + state.slips.length + " riddles answered.";
      nodes.nav.replaceChildren();
      state.slips.forEach(function (id, index) {
        var button = document.createElement("button");
        button.type = "button";
        button.textContent = String(index + 1);
        button.setAttribute("aria-label", "Riddle " + (index + 1) + (state.solved[id] ? ", answered" : ""));
        if (index === state.index) button.setAttribute("aria-current", "true");
        if (state.solved[id]) button.className = "solved";
        button.addEventListener("click", function () {
          state.index = index;
          save();
          setStatus("", "");
          render();
        });
        nodes.nav.append(button);
      });
      nodes.view.replaceChildren();
      var badge = document.createElement("p");
      badge.className = "badge";
      badge.textContent = slip.difficulty;
      var title = document.createElement("h2");
      title.textContent = slip.title;
      var copy = document.createElement("p");
      copy.className = "riddle-copy";
      copy.textContent = slip.text;
      nodes.view.append(badge, title, copy);
      var misses = state.misses[slip.id] || [];
      nodes.choices.replaceChildren();
      api.optionOrder(slip, state.seed).forEach(function (option) {
        var picked = misses.indexOf(option.id) !== -1;
        var right = locked && option.id === slip.correct;
        var button = document.createElement("button");
        button.type = "button";
        button.textContent = option.label;
        if (picked) button.className = "miss";
        if (right) button.className = "hit";
        button.disabled = locked || picked;
        button.addEventListener("click", function () { pick(option.id); });
        nodes.choices.append(button);
      });
      nodes.reveal.hidden = locked;
    }

    function pick(optionId) {
      var api = deck();
      var slip = api.riddleById(currentId());
      if (state.solved[slip.id]) return;
      if (!state.misses[slip.id]) state.misses[slip.id] = [];
      if (state.misses[slip.id].indexOf(optionId) !== -1) return;
      state.tried[slip.id] = true;
      if (api.isCorrect(slip, optionId)) {
        state.solved[slip.id] = true;
        setStatus("Yes. " + slip.answer, "ok");
      } else {
        state.misses[slip.id].push(optionId);
        setStatus("No. That is not the answer.", "bad");
      }
      save();
      render();
    }

    nodes.form.addEventListener("submit", function (event) {
      event.preventDefault();
    });

    function openSpoil() {
      nodes.spoil.hidden = false;
      nodes.spoilNo.focus();
    }

    function closeSpoil() {
      nodes.spoil.hidden = true;
      if (!nodes.reveal.hidden) nodes.reveal.focus();
    }

    nodes.reveal.addEventListener("click", openSpoil);
    nodes.spoilYes.addEventListener("click", function () {
      var slip = deck().riddleById(currentId());
      closeSpoil();
      state.revealed[slip.id] = true;
      state.solved[slip.id] = true;
      setStatus(slip.answer, "ok");
      save();
      render();
    });
    nodes.spoilNo.addEventListener("click", closeSpoil);
    nodes.spoil.addEventListener("click", function (event) {
      if (event.target === nodes.spoil) closeSpoil();
    });

    function deal(seed) {
      state = fresh(seed);
      save();
      setStatus("", "");
      render();
    }

    function openModal() {
      nodes.modal.hidden = false;
      nodes.modalNo.focus();
    }

    function closeModal() {
      nodes.modal.hidden = true;
      nodes.newCase.focus();
    }

    nodes.newCase.addEventListener("click", function () {
      if (hasWork()) openModal();
      else deal(randomSeed());
    });

    nodes.modalYes.addEventListener("click", function () {
      closeModal();
      deal(randomSeed());
    });

    nodes.modalNo.addEventListener("click", closeModal);
    nodes.modal.addEventListener("click", function (event) {
      if (event.target === nodes.modal) closeModal();
    });

    root.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      if (!nodes.spoil.hidden) closeSpoil();
      else if (!nodes.modal.hidden) closeModal();
    });

    nodes.dek.textContent = deck().DEK;
    renderLetter();
    try { state = load(); } catch (err) { state = null; }
    if (!state) state = fresh(randomSeed());
    save();
    render();
  }
})();
